import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs, query, orderBy, where } from "firebase/firestore";
import Spinner from "../../FrontEnd/Integration/Spinner";
import { useAuth } from "../context/AuthContext";
import "../../Css/UserOrders.css";






function FbOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);


  //--- receive user cred
  const {user}=useAuth()

  useEffect(() => {
    const getData = async () => {
      try {
        const ref = query(
          collection(db, "orders"), where('requesterId','==', user?.uid)
          
        );
       
        const snap = await getDocs(ref);

        const result = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

     setOrders(result);
      } catch (err) {
        console.error("Erro ao buscar pedidos:", err);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, []);

  if (loading) return <Spinner/>

  if (orders.length === 0) return <p>Sem pedidos ainda.</p>;


return (
  <> 
    {orders.map(order => (
    <div className="ordersPage">
      <h2>Minhas Compras</h2>
 
      <div  key={order.id} className="orderCard">
        <div className="orderHeader">
          <p>Pedido # {order.id} Cliente: # {order.requester} </p>
          <span>
            {order.data?.toDate
              ? order.data?.toDate().toLocaleDateString()
              : ""}
          </span>
        </div>
  {order.items?.basket?.map((item, i) => (
<>
        <div className="orderProducts">
        
            <div className="orderItem"  key={i} >
              <img src={item.img} alt={i} />
              <div>
                <p>{item.nameProduto}</p>
                <span>Kz:{(item.quantity*item.price)+item?.taxa}</span>
                 <p>Supplier: {item.fornecedor} </p> 
              </div>
            </div>
        </div>

        <div className="tracking">
          <div className={`step ${item?.status === "Pending" ? "active" : "hidden"}`}>
           Pedido Registrado
          </div>
          <div className={`step ${item?.status === "Sold" ? "active" : "hidden"}`}>
          Pacote A Caminho
          </div>
          <div className={`step ${item?.status === "Entregue"? "active" : "hidden"}`}>
            Entregue
          </div>
        </div>
         </>
       ))}
      </div>       
    </div>
      ))}
    </>
  );

}
export default FbOrders;
